export default {
    title: 'Results',
    actionsExecuted: 'No events were logged|One event was logged|{count} events were logged',

    type_default_action: "No actions executed|One action executed|{count} actions executed",
    type_user_deleted: "No user deleted|One user deleted|{count} users deleted",
    type_user_not_deletable: "No user could not be deleted|One user could not be deleted|{count} users could not be deleted"
}
